import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EmployeeStoreService } from 'src/app/company/stores/employee-store.service';
import { PersonalService } from '../services/personal.service';
import { TokenService } from '../services/token.service';
import { PermissionStorageService } from '../storage/permission-storage.service';
import { TokenStorageService } from '../storage/token-storage.service';
import { environment } from 'src/environments/environment';
import { AppStateInterface } from 'src/app/stores/appState.interface';
import { Store } from '@ngrx/store';
import * as EmployeeActions from "../../stores/global/employees/employee-actions";


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  constructor(
    private router: Router,
    private tokenService : TokenService,
    private tokenStorage : TokenStorageService,
    private personalService : PersonalService,
    private permissionStorage : PermissionStorageService,
    private employeeStore: EmployeeStoreService,
    private store: Store<AppStateInterface>
  ) { }

  isLoading = false;

  isProd = environment.production;
  isBeta = environment.beta;
  isStaging = environment.staging;

  readonly version = environment.version;

  loginForm = new UntypedFormGroup({
    tendantId: new UntypedFormControl('', Validators.required),
    email: new UntypedFormControl('', Validators.required),
    password: new UntypedFormControl('', Validators.required)
  });

  ngOnInit(): void {
    // set tenantId that is save in the localstorage
    if(this.tokenStorage.getTenantId){
      const tenantId = this.tokenStorage.getTenantId();
      this.loginForm.patchValue({
        tendantId: tenantId
      })
    }
  }

  onSubmit(){
    this.isLoading = true;
    const formValues = this.loginForm.value;
    this.tokenService.signIn(formValues, formValues.tendantId.toLowerCase())
      .subscribe(response => {
          if(response.token)
          this.tokenStorage.saveToken(response.token)
          if(response.refreshToken)
          this.tokenStorage.saveRefreshToken(response.refreshToken)
          this.tokenStorage.saveTenantId(formValues.tendantId.toLowerCase());
          this.personalService.getPermissionOfCurrentUser()
          .subscribe(permissions => {
            this.permissionStorage.savePermissions(permissions);
            this.router.navigate(['/']);
            this.isLoading = false;
            this.employeeStore.getCurrentEmployee();
            this.store.dispatch(EmployeeActions.getCurrentEmployee());
          },
          error => this.isLoading = false
          )
      },
      error => this.isLoading = false
      )
  }
}
